/* eslint-disable */
import React, { useState, useEffect, useContext, useMemo } from "react";
import { MaterialReactTable } from "material-react-table";
import { defaultTableConfig, withStrictFilter } from "Config/tableConfig";
import * as XLSX from "xlsx";
//import translation function for language translation
import { useTranslation } from "react-i18next";
//import api requiremnts
import * as url from "urlhelpers/UrlHelper";
import { currencySymbol } from "Config/Config";
import { getData, postData } from "utils/Gateway";
import { Link } from "react-router-dom";
//import context
import { GlobalProvider } from "context/GlobalContext";

const BudgetList = ({
  downloadExcel,
  checkedRecordCount,
  search,
  setRecords,
}) => {
  const {
    setSalesOrderData,
    reloadSalesOrderList,
    setReloadSalesOrderList,
    showSalesOrderInvoiceIdColumn,
    showSalesOrderClientColumn,
    showSalesOrderInvoiceDateColumn,
    showSalesOrderBudgetStatusColumn,
    showSalesOrderDiscountColumn,
    showSalesOrderTotalAmountColumn,
    showSalesOrderCreatedDateColumn,
    showSalesOrderPayblePriceColumn,
    // ----- search requriement -----
    searchSalesOrderDate,
    setSearchSalesOrderDate,
    searchSalesOrderDateType,
    setSearchSalesOrderDateType,
    searchSalesOrderClients,
    setSearchSalesOrderClients,
    searchSalesOrderBudgetStatus,
    setSearchSalesOrderBudgetStatus,
    searchSalesOrderDiscount,
    setSearchSalesOrderDiscount,
    //notification
    setSuccess,
    setError,
    setNotificationString,
    screenHeight,
    isBudgetLoading,
    setIsBudgetLoading,
  } = useContext(GlobalProvider);
  const token = localStorage.getItem("token");
  const { t } = useTranslation(); //for translation
  const [salesOrderList, setSalesOrderList] = useState([]);
  const [salesOrderItemsData, setSalesOrderItemsData] = useState([]);
  const [rowSelection, setRowSelection] = useState({});
  const [columnFilters, setColumnFilters] = useState([]);

  const getSelectedData = () => {
    const selectedIds = Object.keys(rowSelection).filter((key) => rowSelection[key]);
    return salesOrderList.filter((item) => selectedIds.includes(item._id));
  };

  const exportExcel = () => {
    const selectedRecords = getSelectedData();
    let exportItemsData;
    if (selectedRecords.length > 0) {
      exportItemsData = selectedRecords.flatMap((order) => order.salesorderitems || []);
    } else {
      exportItemsData = salesOrderItemsData;
    }
    const rows = exportItemsData.map((item) => ({
      [t("Order_date")]: item.orderdate || "",
      [t("Client_name")]: item.customer || "",
      [t("Order_Id")]: item.orderid || "",
      [t("SERIE_ALIAS")]: item.SERIE_ALIAS || "",
      [t("Order_Status")]: item.orderstatus || "",
      [t("Category")]: item.category || "",
      [t("Client_Observation")]: item.clientobservation || "",
      [t("Internal_Observation")]: item.internalobservation || "",
      [t("Payment_Form")]: item.paymentform || "",
      [t("Payment_Terms")]: item.paymentterms || "",
      [t("Product")]: item.activityname || "",
      [t("Concept_Description")]: item.conceptdescription || "",
      [t("Concept_Observation")]: item.conceptobservation || "",
      [t("Units")]: item.unit || "",
      [t("Unit_Price")]: item.activitycost || "",
      [t("Percent_Retention")]: item.retention || "",
      [t("Percent_Tax")]: item.taxpercent || "",
      [t("Discount")]: item.discountpercent || "",
      [t("Due_Date")]: item.duedate || "",
      [t("Total_Price")]: item.totalprice || "",
    }));
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Budget");
    XLSX.writeFile(wb, "Funbrain_Sales_Order.xlsx");
  };

  // sync to billage platform
  const syncToBillage = async (salesOrderId) => {
    let requestUrl =
      url.API_BASEURL +
      url.API_SYNC_BILLAGE +
      `/${salesOrderId}` +
      `?token=${token}`;
    const response = await getData(requestUrl);
    console.log(response);
    if (response.status) {
      setSuccess(true);
      setNotificationString(t("Invoice Sync Successfully"));
      setReloadSalesOrderList(true);
    } else {
      setError(true);
      setNotificationString(t("Something went wrong, please try again later"));
    }
  };

  //sales order id html
  const salesOrderBlockHtml = ({ dataItem }) => {
    return (
      <div className="d-flex align-items-center">
        <p className="name mb-1">{dataItem.invoiceid}</p>
        <Link
          to="#saveBudgetPopup"
          data-bs-toggle="offcanvas"
          onClick={() => {
            setSalesOrderData(dataItem._id);
          }}
          className="float-end ms-2"
        >
          <span
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title={t("Edit Budget")}
            className="d-block material-symbols-outlined icon-md"
          >
            edit
          </span>
        </Link>
        <Link
          to={`/salesorder/invoice/${dataItem._id}`}
          className="float-end ms-2"
          target="_blank"
        >
          <span
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title={t("View in pdf")}
            className="d-block material-symbols-outlined icon-md"
          >
            picture_as_pdf
          </span>
        </Link>
        {dataItem.syncbillage ? (
          <Link to="#" className="float-end ms-2">
            <span
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title={t("Billage synced")}
              className="d-block material-symbols-outlined icon-md text-green"
            >
              credit_score
            </span>
          </Link>
        ) : (
          <>
            <button
              className=" bg-transparent p-0 border-0 ms-2"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title={t("Sync to billage")}
                className="d-block material-symbols-outlined text-red"
              >
                payment
              </span>
            </button>
            <ul className="dropdown-menu border-0 shadow-lg ">
              <li>
                <Link
                  to="#"
                  className="dropdown-item"
                  onClick={() => {
                    syncToBillage(dataItem._id);
                  }}
                >
                  {t("Sync to Billage")}
                </Link>
              </li>
            </ul>
          </>
        )}
      </div>
    );
  };

  //totalAmountCell
  const totalAmountCell = ({ dataItem }) => {
    return (
      <div>
        <p>
          {dataItem.totalactivitycost} {currencySymbol}
        </p>
      </div>
    );
  };

  //payble cell
  const paybleAmountCell = ({ dataItem }) => {
    return (
      <div>
        <p>
          {dataItem.totalpaybleprice} {currencySymbol}
        </p>
      </div>
    );
  };

  //totalSalesorderAmountCell
  const totalSalesorderAmountCell = ({ dataItem }) => {
    return (
      <div>
        <p>
          {dataItem.totalsalesorderamount} {currencySymbol}
        </p>
      </div>
    );
  };

  //function for get all budget records
  const getAllSalesRecords = async (currentSearch = search) => {
    setIsBudgetLoading(true);
    try {
      let requestUrl =
        url.API_BASEURL +
        url.API_GET_ALL_SALES_ORDER +
        `?token=${token}&ordertypequery=1`;
      if (searchSalesOrderDate != "" && searchSalesOrderDateType != null) {
        requestUrl =
          requestUrl +
          `&salesdate=${searchSalesOrderDate}&salesdatetype=${searchSalesOrderDateType}`;
      }
      if (searchSalesOrderClients.length > 0) {
        requestUrl = requestUrl + `&salesclients=${searchSalesOrderClients}`;
      }
      if (searchSalesOrderBudgetStatus.length > 0) {
        requestUrl =
          requestUrl +
          `&salesorserbudgetstatus=${searchSalesOrderBudgetStatus}`;
      }
      if (searchSalesOrderDiscount != 0) {
        requestUrl = requestUrl + `&salesdiscount=${searchSalesOrderDiscount}`;
      }
      if (currentSearch?.trim()) {
        requestUrl += `&globalsearch=${encodeURIComponent(currentSearch.trim())}`;
      }
      console.log("url for budget list------->", requestUrl);
      const response = await getData(requestUrl);
      console.log("response in budget------->", response);
      if (response.status) {
        setSalesOrderList(response.data);
        setRecords(response.data.length);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsBudgetLoading(false);
    }
  };

  const getSalesOrderItemsData = () => {
    console.log("salesOrderList", salesOrderList.length);
    let salesOrderItemArray = [];
    if (salesOrderList.length > 0) {
      salesOrderList.map((salesOrder) => {
        if (salesOrder.salesorderitems.length > 0) {
          salesOrder.salesorderitems.map((orderItem) => {
            salesOrderItemArray.push(orderItem);
          });
        }
      });
      setSalesOrderItemsData(salesOrderItemArray);
      console.log("salesOrderItemsData", salesOrderItemsData);
    }
  };

  const tableColumns = useMemo(() => {
    const cols = [];
    if (showSalesOrderInvoiceIdColumn) {
      cols.push({
        id: "invoiceid",
        accessorKey: "invoiceid",
        header: t("Order Id"),
        Cell: ({ row }) => salesOrderBlockHtml({ dataItem: row.original }),
        size: 200,
      });
    }
    if (showSalesOrderClientColumn) {
      cols.push({
        id: "clientfullname",
        accessorKey: "clientfullname",
        header: t("Client"),
        size: 300,
      });
    }
    if (showSalesOrderInvoiceDateColumn) {
      cols.push({
        id: "salesorderinvoicedate",
        accessorKey: "salesorderinvoicedate",
        header: t("Order Date"),
        size: 200,
      });
    }
    if (showSalesOrderBudgetStatusColumn) {
      cols.push({
        id: "budgetstatus",
        accessorKey: "budgetstatus",
        header: t("Budget Status"),
        size: 200,
      });
    }
    if (showSalesOrderTotalAmountColumn) {
      cols.push({
        id: "totalactivitycost",
        accessorKey: "totalactivitycost",
        header: t("Total Amount"),
        Cell: ({ row }) => totalAmountCell({ dataItem: row.original }),
        size: 200,
      });
    }
    if (showSalesOrderDiscountColumn) {
      cols.push({
        id: "discountpercent",
        accessorKey: "discountpercent",
        header: t("Discount") + ` %`,
        size: 200,
      });
    }
    if (showSalesOrderPayblePriceColumn) {
      cols.push({
        id: "totalpaybleprice",
        accessorKey: "totalpaybleprice",
        header: t("Payable Amount"),
        Cell: ({ row }) => paybleAmountCell({ dataItem: row.original }),
        size: 200,
      });
    }
    cols.push({
      id: "totalsalesordercount",
      accessorKey: "totalsalesordercount",
      header: t("Sales Order"),
      size: 200,
    });
    cols.push({
      id: "totalsalesorderamount",
      accessorKey: "totalsalesorderamount",
      header: t("Sales Order Amount"),
      Cell: ({ row }) => totalSalesorderAmountCell({ dataItem: row.original }),
      size: 200,
    });
    if (showSalesOrderCreatedDateColumn) {
      cols.push({
        id: "salesordercreateddate",
        accessorKey: "salesordercreateddate",
        header: t("Created Date"),
        size: 200,
      });
    }
    return withStrictFilter(cols);
  }, [
    salesOrderList,
    t,
    showSalesOrderInvoiceIdColumn,
    showSalesOrderClientColumn,
    showSalesOrderInvoiceDateColumn,
    showSalesOrderBudgetStatusColumn,
    showSalesOrderDiscountColumn,
    showSalesOrderTotalAmountColumn,
    showSalesOrderCreatedDateColumn,
    showSalesOrderPayblePriceColumn,
  ]);

  useEffect(() => {
    if (
      (searchSalesOrderDate != "" && searchSalesOrderDateType != null) ||
      searchSalesOrderClients.length > 0 ||
      searchSalesOrderBudgetStatus.length > 0 ||
      searchSalesOrderDiscount != 0
    ) {
      getAllSalesRecords();
    }
  }, [
    searchSalesOrderDate,
    searchSalesOrderDateType,
    searchSalesOrderClients,
    searchSalesOrderBudgetStatus,
    searchSalesOrderDiscount,
  ]);

  useEffect(() => {
    if (reloadSalesOrderList) {
      getAllSalesRecords();
      setReloadSalesOrderList(false);
    }
  }, [reloadSalesOrderList]);

  /* initial load + refetch when search changes */
  useEffect(() => {
    getAllSalesRecords(search);
  }, [search]);

  useEffect(() => {
    downloadExcel && exportExcel();
  }, [downloadExcel]);

  useEffect(() => {
    getSalesOrderItemsData();
  }, [salesOrderList]);

  /* sync selected count to parent */
  useEffect(() => {
    const selectedCount = Object.keys(rowSelection).filter((key) => rowSelection[key]).length;
    checkedRecordCount(selectedCount);
  }, [rowSelection, salesOrderList]);

  /* Reset selection when list changes (after delete/reload) */
  useEffect(() => {
    setRowSelection({});
  }, [salesOrderList]);

  return (
    <div className="table-responsive">
      {/* Hidden checkboxes for header delete/mail actions */}
      <div style={{ display: "none" }}>
        {salesOrderList.map((order) => (
          <input
            key={order._id}
            type="checkbox"
            name="selectSalesOrderRecord"
            value={order._id}
            data-emailstring={order.clientemail || ""}
            checked={!!rowSelection[order._id]}
            onChange={() => {}}
          />
        ))}
      </div>
      <MaterialReactTable
        {...defaultTableConfig}
        enableGlobalFilter
        globalFilterFn="strictContains"
        columns={tableColumns}
        data={salesOrderList}
        enableSorting
        enableGrouping
        enableColumnOrdering
        enableStickyHeader
        enableRowSelection
        onRowSelectionChange={setRowSelection}
        onColumnFiltersChange={setColumnFilters}
        getRowId={(row) => row._id}
        state={{ rowSelection, columnFilters, isLoading: isBudgetLoading }}
        renderLoadingOverlay={() => null}
        muiLinearProgressProps={{ sx: { display: "none" } }}
        muiCircularProgressProps={{ sx: { display: "none" } }}
        muiTableContainerProps={{ sx: { maxHeight: screenHeight || "70vh" } }}
        muiTableBodyRowProps={{ sx: { overflow: "visible" } }}
        muiTableBodyProps={{ sx: { overflow: "visible" } }}
      />
    </div>
  );
};
export default BudgetList;
